// src/redux/api/transactionApi.js
import { withDefaultMeta } from "../../util/withDefaultMeta";
import { apiSlice } from "../../app/apiSlice";

export const wooApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const query = withDefaultMeta(builder.query);
    const mutation = withDefaultMeta(builder.mutation);
    return {
      // 🔹 Get all Woo products
      // 🔹 Get Products with filters
      getWooProducts: query({
        query: ({ category, search, min_price, max_price, page = 1 }) => {
          const params = new URLSearchParams({
            page,
            per_page: 20,
            ...(category ? { category } : {}),
            ...(search ? { search } : {}),
            ...(min_price ? { min_price } : {}),
            ...(max_price ? { max_price } : {}),
          });
          return `/woo/products?${params.toString()}`;
        },
      }),

      // 🔹 Get single Woo product by ID
      getWooProductById: query({
        query: (id) => `/woo/products/${id}`,
        meta: { requiresAuth: false },
      }),

      getWooProductsByIds: query({
        query: (ids) => `/woo/products/by-ids?ids=${ids}`,
      }),

      getMyWooOrders: query({
        query: () => "/woo/orders/my",
      }),

      // 🔹 Get Woo categories
      getWooCategories: query({
        query: () => `/woo/categories`,
      }),

      createWooOrder: mutation({
        query: (orderData) => ({
          url: "/woo/orders",
          method: "POST",
          body: orderData,
        }),
      }),
    };
  },
});

export const {
  useGetWooProductsByIdsQuery,
  useGetWooCategoriesQuery,
  useGetWooProductByIdQuery,
  useGetWooProductsQuery,
  useGetMyWooOrdersQuery,
  useCreateWooOrderMutation,
} = wooApiSlice;
